<template>
  <div>
    <div class="content-tool">
      <div class="content-tool--nav" style="width: 30%;">
        <div class="content-tool--title fl">公司</div>
        <!-- <el-input placeholder="请输入操作人" icon="search" v-model.trim="opName" @keyup.enter.native="fetchExcelImports" class="content-tool--input fl"></el-input> -->
        <el-select v-model="providerId" filterable>
          <el-option v-for="p in providers" :key="p.providerId" :label="p.providerName" :value="p.providerId"></el-option>
        </el-select>
      </div>
      <div class="content-tool--nav" style="width: 45%;">
        <div class="content-tool--title fl" style="width: 100px;">excel 上传时间</div>
        <el-date-picker v-model="times" type="daterange" :picker-options="pickerOptions" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
      </div>
      <div class="content-tool--nav" style="padding: 10px 0px 0px 0px;">
        <el-button type="primary" class="content-tool--qry el-button-reset" @click="fetchExcelImports">查询</el-button>
        <el-button class="content-tool--reset el-button-reset" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="content-search-title" v-if="$store.state.ispay == 1" style="width: 100%; overflow: hidden;">
      <el-upload class="my-el-button-reset fl" style="margin-left: 37px;" action="" accept=".xls,.xlsx" :show-file-list="false" :http-request="uploadExcel">
        <el-button size="medium" type="primary" >新增发放</el-button>
      </el-upload>
      <div class="display-inline-block content-tip fl">提示：只能上传 excel 文档</div>
      <el-button type="primary" @click="templateDownload" size="medium" style="margin-left: 20px;">模板下载</el-button>
    </div>
    <div class="content-table">
      <el-table :data="payRecords" size='medium' row-click="fetchRowDetail" tooltip-effect="dark">
        <el-table-column prop="providerName" label="公司" width="280px" align="left"></el-table-column>
        <el-table-column prop="opName" label="操作人" width="120px" align="left"></el-table-column>
        <el-table-column prop="opTime" label="excel 上传日期" align="center"></el-table-column>
        <el-table-column prop="excelName" label="excel 文件名" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="totalNum" label="总记录数" width="80px" align="left"></el-table-column>
        <el-table-column prop="sucNum" label="成功数" width="80px" align="left"></el-table-column>
        <el-table-column prop="failNum" label="失败数" width="80px" align="left"></el-table-column>
        <el-table-column prop="isSign" label="是否签约" width="80px" align="left"></el-table-column>
        <el-table-column prop="status" label="操作" width="80px" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.excelStatus == 5">
              <div class="detail-name" @click="fetchDetail(scope.row)">取消转账</div>
            </div>
            <div v-else-if="$store.state.ispay == 1">
              <div class="detail-name" v-if="scope.row.status == 0" @click="jumpPay(scope.row, 0)">审核中</div>
              <div class="detail-name-txt" v-if="scope.row.status == 1">复核中</div>
              <div class="detail-name" v-if="scope.row.status == 2" @click="jumpPay(scope.row, 0)">审核不通过</div>
              <div class="detail-name" v-if="scope.row.status == 3" @click="beginPay(scope.row)">开始转账</div>
              <div class="detail-name" v-if="scope.row.status == 4" @click="fetchDetail(scope.row)">复核不通过</div>
              <div class="detail-name" v-if="scope.row.status == 5" @click="fetchDetail(scope.row)">转账详情</div>
            </div>
            <div v-else-if="$store.state.ischeck == 1">
              <div class="detail-name-txt" v-if="scope.row.status == 0">审核中</div>
              <div class="detail-name" v-if="scope.row.status == 1" @click="jumpPay(scope.row, 1)">复核中</div>
              <div class="detail-name-txt" v-if="scope.row.status == 2">审核不通过</div>
              <div class="detail-name-txt" v-if="scope.row.status == 3">开始转账</div>
              <div class="detail-name" v-if="scope.row.status == 4" @click="jumpPay(scope.row, 1)">复核不通过</div>
              <div class="detail-name" v-if="scope.row.status == 5" @click="fetchDetail(scope.row)">转账详情</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog modal title="excel 中以下记录有问题，请修改后重新提交" :visible.sync="excelHasError" width="70%">
      <el-table :data="payResultVO.failVOs" size='medium' tooltip-effect="dark">
        <el-table-column prop="id" label="序号" align="center" width="100px"></el-table-column>
        <el-table-column prop="userName" label="姓名" align="center" width="100px"></el-table-column>
        <el-table-column prop="cardid" label="身份证号" align="center" width="200px"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center" width="170px"></el-table-column>
        <el-table-column prop="bankno" label="银行卡号" align="center" width="200px"></el-table-column>
        <el-table-column prop="reason" label="失败原因"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/api';
import { Loading } from 'element-ui';
// import { parseTime } from '@/utils';

export default {
  name: 'payexcels',
  data() {
    return {
      payRecords: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      payResultVO: {
        sucNum: 0,
        failNum: 0,
        failReason: [],
      },
      providers: [],
      providerId: null,
      times: [],
      excelHasError: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 7));
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 30));
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 90));
            picker.$emit('pick', [start, end]);
          },
        }],
      },
    };
  },
  mounted() {
    this.reset();
    this.fetchExcelImports();
    this.fetchProviders();
  },
  methods: {
    uploadExcel(param) {
      const eleLoading = Loading.service({
        lock: true,
        text: '文件正在上传中...',
        spinner: 'el-icon-loading',
        background: '(0,0%,100%,.9)',
      });
      // 现代浏览器导入
      const fileObj = param.file;
      const formData = new FormData();
      const fileTypeReg = /\.(xls|xlsx)$/gi;
      formData.append('file', fileObj);
      formData.append('fileName', fileObj.name);
      formData.append('fileSize', fileObj.size);

      // 校验满足条件的文件
      if (!fileTypeReg.test(fileObj.name)) {
        eleLoading.close();
        this.$message.error('请选择 excel 文件上传');
        return;
      }
      if (fileObj.length > 1) {
        eleLoading.close();
        this.$message.error('最多上传一个文件');
        return;
      }

      const params = {
        data: formData,
      };
      api.upload({ params }).then((result) => {
        eleLoading.close();
        this.payResultVO = result;
        if (this.payResultVO.failNum === 0) {
          this.$message({
            message: '上传成功，请核对转账记录开始转账',
            type: 'success',
          });
          this.excelHasError = false;
          const par = {
            opId: this.payResultVO.opId,
            status: 0,
          };
          this.$router.push({ path: 'payimport', query: par });
        } else if (this.payResultVO.failNum > 0) {
          this.excelHasError = true;
          // this.$message({
          //   message: this.payResultVO.failResult,
          //   type: 'error',
          // });
        }
      }).catch(() => {
        eleLoading.close();
        this.$message({
          message: '导入失败，请稍后重试',
          type: 'error',
        });
      });
    },
    fetchExcelImports() {
      this.payRecords = [];
      const params = {
        index: this.currentPage - 1,
        size: this.pageSize,
        providerId: this.providerId,
      };
      if (this.times && this.times.length === 2) {
        params.beginTime = new Date(this.times[0]).getTime();
        params.endTime = new Date(this.times[1]).getTime();
      }
      api.fetchExcelImports({
        params: {
          params,
        },
      }).then((res) => {
        this.payRecords = [];
        this.total = 0;
        if (!res) {
          return;
        }
        this.total = res.count;
        if (!res.data) {
          return;
        }
        res.data.forEach((element) => {
          this.payRecords.push({
            opId: element.opId,
            providerName: element.providerName,
            excelName: element.excelName,
            excelSize: element.excelSize,
            opTime: element.opTime,
            opName: element.opName,
            totalNum: element.totalNum,
            sucNum: element.status !== 5 ? '-' : element.sucNum,
            failNum: element.status !== 5 ? '-' : element.failNum,
            status: element.status,
          });
        });
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    fetchDetail(row) {
      const params = {
        opId: row.opId,
        totalNum: row.totalNum,
        sucNum: row.sucNum,
        failNum: row.failNum,
      };
      this.$router.push({ path: 'exceldetail', query: params });
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchExcelImports();
    },
    reset() {
      this.providerId = null;
      this.times = [];
    },
    jumpPay(row, ischeck) {
      const params = {
        opId: row.opId,
        status: row.status,
        ischeck,
      };
      this.$router.push({ path: 'payimport', query: params });
    },
    beginPay(row) {
      this.$confirm('确认开始转账 ?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        api.payEnable({
          params: {
            params: {
              opId: row.opId,
              status: 5,
              ispass: 1,
            },
          },
        }).then(() => {
          this.fetchExcelImports();
        }).catch((err) => {
          console.log(err);
          this.$message({
            type: 'error',
            message: err.response.msg,
            duration: 5000,
          });
        });
      }).catch(() => {
      });
    },
    templateDownload() {
      // eslint-disable-next-line
      window.location = `./static/template.xlsx`;
    },
    fetchProviders() {
      api.fetchProviders().then((res) => {
        console.log(res);
        if (!res) {
          return;
        }
        this.providers = res;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>

/*
@media screen and (max-width: 1200px) {
  .app-main {
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .app-main {
    width: 1200px;
  }
}
*/

.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-tool {
  padding: 27px 17px 20px 17px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  margin: 40px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
    padding: 0px 17px 20px 17px;
    margin: 0px 20px 20px 20px;
  }
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/payexcels.vue